<div class="ai-terms-of-use" dialogContent>
    <h1>TALENT ALL ACCESS® PORTAL+ TERMS & CONDITIONS</h1>

    <h2>1 INTRODUCTION</h2>
    <p>
        1.1 These terms and conditions (the “Terms and Conditions”) are incorporated into, and form
        part of, the purchase agreement made between you and us (the “Agreement” and together with
        the Terms and Conditions, the “Engagement Terms”).
    </p>
    <p>
        1.2 We are a provider of TALENT ALL ACCESS® PORTAL+ (the “Platform”), a portfolio of data
        products that cover a range of human resource topics such as benefits and compensation.
    </p>
    <p>
        1.3 The Platform is owned or operated by us or one of our Affiliates (together “Marsh
        McLennan”). The solutions are comprised of Marsh McLennan’s proprietary software, data,
        methodology and other property, along with third party software, data and methodology
        licensed by Marsh McLennan.
    </p>

    <h2>2 2 DEFINTIONS</h2>
    <p>
        2.1 Any capitalised terms used but not defined in these Terms and Conditions shall have the
        meaning given to them in the Agreement.
    </p>
    <p>
        2.2 “AI Technology” means is a machine-based system designed to operate with varying levels
        of autonomy (meaning without significant human oversight) and that may exhibit adaptiveness
        after deployment and that, for explicit or implicit objectives, infers, from the input it
        receives, how to generate outputs such as predictions, content, recommendations, or
        decisions that can influence physical or virtual environments.
    </p>
    <p>
        2.3 “Affiliate” means, with respect to a party, an entity that (directly or indirectly)
        controls, is controlled by or is under common control with, such party, where control refers
        to the power to direct or cause the direction of the management policies of another entity,
        whether through ownership of voting securities, by contract or otherwise.
    </p>
    <p>2.4 “Aida” means chatbot functionality available on the Platform.</p>
    <p>
        2.5 “Data Protection Laws” means all mandatory laws, regulations, or any binding guidance or
        opinions issued by any relevant Regulator worldwide applicable to the Processing of Personal
        Data under the Agreement.
    </p>
    <p>2.6 “Engagement Terms” has the meaning given to it in paragraph 1.1.</p>
    <p>
        2.7 “Fees” means the fees and expenses payable by you for the Services as stated in the
        Agreement.
    </p>
    <p>
        2.8 “Intellectual Property” means all copyrights, patents, trademarks, service marks,
        business names and domain names, goodwill, designs right, rights in computer software,
        database rights, methodologies, know-how and trade secrets, and all other intellectual
        property rights, in each case whether registered or unregistered in any part of the world.
    </p>
    <p>
        2.9 "Loss" or "Losses" means any loss, damage, costs, expenses, awards, penalties, claims
        (including third party claims), or any other payment, of whatever kind and however incurred.
        Multiple claims arising out of or based upon the same act, error or omission, or series of
        continuous, interrelated or repeated acts, errors or omissions shall be considered a single
        loss.
    </p>
    <p>2.10 “Marsh McLennan” has the meaning given to it in paragraph 1.2.</p>
    <p>2.11 “Materials” means all published content on the Platform.</p>
    <p>
        2.12 “Platform Terms of Use” means the terms of use governing a User’s use of the Platform
        that is available on the Platform.
    </p>
    <p>
        2.13 “Prohibited Use Policy” means the policy on prohibited use of the Products and access
        to the Platform found at Schedule 1.
    </p>
    <p>
        2.14 “Services” means the provision the Materials and access to the Platform as specified in
        the Agreement.
    </p>
    <p>2.15 “User” means individuals of the Client who may access the Platform.</p>

    <h2>3 INTELLECTUAL PROPERTY AND ACCESS</h2>
    <p>
        3.1 Except as expressly granted to you under the Engagement Terms, we retain all
        Intellectual Property subsisting in the Materials and the Platform, including, without
        limitation, in respect of the methodologies, methods of analysis, ideas, concepts, know-how,
        techniques, models, knowledge definitions, terminologies, tools, data, information,
        arrangements and structures, text, graphics and images in the Materials and the Platform.
    </p>
    <p>
        3.2 We grant you a non-exclusive, non-transferrable, royalty free license during the Term
        to:
    </p>
    <ol type="a">
        <li>
            access the Materials and Platform specified in the Engagement Terms up to the number of
            accounts or licenses specified in the Engagement Terms; and
        </li>
        <li>
            use the Materials and the Platform, and the Intellectual Property in the Materials and
            the Platform, for your own internal research, assessment, and analysis purposes.
        </li>
    </ol>
    <p>
        3.3 You may not create derivative works of the Materials or the Platform without our prior
        written consent. Any alterations, updates, derivative works, translations, modifications,
        updates, adaptations, enhancements and new developments of the Materials or the Platform, if
        any, created by or on behalf of us during the Term shall be solely owned by Marsh McLennan.
    </p>
    <p>
        3.4 Subject to clause 3.5, you will not provide access to the Materials or Platform, in
        whatever form, to any third party without our prior written consent, which may be withheld,
        conditioned or delayed at our absolute discretion and we may require the third party to
        enter into a direct contractual relationship with us.
    </p>
    <p>
        3.5 We may monitor use of the Materials and Platform and upon request, you shall provide us
        with details of individuals provided with access to the Materials. Should this list include
        access beyond that which is permitted in the Engagement Terms, we may issue an invoice to
        you for our outstanding fees or terminate your access to the Services immediately.
    </p>
    <p>
        3.6 You shall ensure that you and all Users comply with the Prohibited Use Policy, the
        Platform Terms of Use and applicable laws in connection with the use of and access to the
        Materials and the Platform. You shall be fully liable for the acts and omissions of a User
        in respect of such compliance as if they were your own acts and omission.
    </p>
    <p>
        3.7 We may suspend or limit the use of or access to the Materials or the Platform if you or
        a User’s use of the Materials or the Platform breaches the Prohibited Use Policy or
        applicable laws in connection with the use of and access to the Materials and the Platform.
    </p>
    <p>
        3.8 If we reasonably determine or suspect that you or a User are competitors, commercial
        users or an entity or individual that resells or redistributes the Materials or access to
        the Platform or offerings or data from Platform in any way (a “competitor”), we may in our
        sole discretion, elect to: (1) require you to pay higher fees for the Services, including
        those which may have already been provided under these Engagement Terms; (2) discontinue
        your access to the Platform and the Materials immediately; and/or (3) terminate the
        Engagement Terms immediately.
    </p>
    <p>
        3.9 You shall be responsible for, and maintain, all licenses and other rights necessary to
        access and use the software or systems that required in order to access and use the
        Materials and the Platform, including a supported web browser, communication lines and
        equipment; a supported version of Microsoft Office; and a supported version of a PDF
        document reader (the "Systems") and all charges related thereto. You acknowledge that the
        speed of access to the Materials and the Platform will depend upon the quality of your own
        systems and your connection to the Internet.
    </p>
    <p>
        3.10 We shall have the right to discontinue any of the Materials (or part thereof) at any
        time during the Term, or to reduce or remove any Platform functionality where we have a
        commercial or technical reason to do so (including changes to the underlying software,
        security protocols or technical configurations). Your access to and use of the Materials and
        the Platform will be subject to such updates and we will not be liable for any
        failure/inability by you to use the Materials or the Platform as a consequence of such
        updates.
    </p>
    <p>
        3.11 You acknowledge that we may from time to time carry out planned or unplanned
        maintenance of the Platform during the Term, and that you or a User may be unable to access
        some or all of the Materials during such time.
    </p>

    <h2>4 LIMITATIONS AND EXCLUSIONS</h2>
    <p>
        4.1 Except as expressly set out in the Engagement Terms, we make no warranties or
        representations with respect to the Materials, the Platform or any part thereof, and exclude
        all express, implied, and statutory warranties of any kind to you or any third party,
        including, but not limited to, representations and warranties regarding accuracy,
        timeliness, completeness, merchantability, fitness for any particular purpose, and/or
        freedom from computer virus.
    </p>
    <p>
        4.2 You accept the Materials on an “as is” basis. You acknowledge that the Materials are for
        general information and use only and are not conclusive. In particular, the Materials do not
        constitute any form of advice, recommendation, representation, or arrangement by us and you
        are solely responsible for any conclusions you draw from the Materials or decisions you make
        based on the Materials. Without limiting the foregoing, the Materials must not be relied
        upon as statements of fact or as the sole basis for any employment related decisions.
    </p>
    <p>
        4.3 You are fully liable and responsible for accuracy and completeness of the information
        provided to us by you or on your behalf (the “Information”). We shall have no responsibility
        for any inaccuracies in the Materials resulting from inaccuracies in or the incompleteness
        of the Information.
    </p>
    <p>
        4.4 You acknowledge and accept all figures contained in the Materials or on the Platform may
        be subject to the limits of statistical errors/rounding up or down.
    </p>

    <h2>5 FEES AND PAYMENT</h2>
    <p>
        5.1 In consideration for provision of the Materials and access to the Platform, you will pay
        (or cause to be paid) the Fees in accordance with the terms of the Agreement.
    </p>

    <h2>6 TERM AND TERMINATION</h2>
    <p>
        6.1 The terms governing the term and termination of the Engagement Terms are set out in the
        Agreement.
    </p>

    <h2>7 LIABILITY</h2>
    <p>
        7.1 The maximum aggregate liability of us, our Affiliates and any officer, director,
        employee or subcontractor of us or our Affiliates (the “Marsh McLennan Parties”) to you, the
        Users, your officers, directors, employees, Affiliates and any third party (including any
        benefit plan, its fiduciaries or any plan sponsor) whether in contract, tort (including
        negligence and breach of statutory duty) or otherwise for any and all Losses arising out of
        or relating to the provision of Services under the Engagement Terms shall not exceed three
        (3) times the Fees. The Marsh McLennan Parties shall have no liability for the acts or
        omissions of any third party.
    </p>
    <p>
        7.2 Neither party nor its Affiliates shall be liable in connection with the Engagement Terms
        or arising out of or relating to the provision and use of the Services for any loss of
        profit, revenues, anticipated savings, business or investment opportunities, goodwill,
        internal or management costs or any other indirect, special, incidental or consequential
        loss. This clause applies even if a party or its Affiliate, or representatives thereof, is
        advised of the possibility of such loss.
    </p>
    <p>
        7.3 Without limitation to the foregoing, you acknowledge that the Materials, the Platform
        and the assumptions, information and data contained therein may be incomplete or condensed
        and that the assumptions, information and data obtained through your access and use of the
        Materials and the Platform are for general information purposes only and are not intended
        as, nor implied to be, a substitute for professional advice. In no event will Marsh McLennan
        Parties be liable to you or to any third party for any decision made or action taken in
        reliance of the results or conclusions obtained through the access and use of such
        information or data.
    </p>
    <p>
        7.4 You acknowledge that no defence or indemnity of any kind is provided hereunder by Marsh
        McLennan Parties with respect to any claim, demand, cause of action, cost, loss, damage,
        expense or liability arising from or based on your or any third party's use of or inability
        to use the Platform or the Materials.
    </p>
    <p>
        7.5 Nothing in the Engagement Terms is intended to exclude any liability that cannot by law
        or regulation be excluded or restricted.
    </p>
    <p>
        7.6 We may grant a demonstration license ("Demo License") to you to access and use the
        Materials and the Platform for a limited period of time for no charge. Notwithstanding
        paragraph 7.1, in no event shall we be liable to you or any third party for any claims or
        losses in connection with a Demo License.
    </p>

    <h2>8 CONFIDENTIALITY</h2>
    <p>
        8.1 Unless required by law, governmental or regulatory authority and subject to the remainer
        of this clause, each party undertakes to keep confidential, and not to disclose, any
        confidential information (written or oral) of the other or of a User which is provided in
        connection with the Services.
    </p>
    <p>
        8.2 The provisions of clause 8.1 will not apply to information which is already lawfully in
        the possession of the other party on date of its disclosure and/or in the public domain
        other than as a result of a breach of clause 8.1.
    </p>
    <p>8.3 We are entitled to disclose your confidential information to:</p>

    <ol type="a">
        <li>our Affiliates;</li>
        <li>other third parties with your written consent</li>
        <li>
            our advisors, directors, officers, employees, representatives, sub-contractors or
            Affiliates involved in the provision of the Services, who in each case agree to keep
            such information confidential; and
        </li>
        <li>
            our legal advisers, insurers and insurance brokers where it is necessary for us to
            notify them of a claim or circumstances that might lead to a claim..
        </li>
    </ol>

    <p>
        8.4 Neither party shall use the other’s confidential information for any purpose other than
        the provision or use of the Services, save that we shall be permitted to retain your
        confidential information for your further use within the Platform to use your and a User’s
        confidential information to create analytical trend data, normative databases, aggregated
        statistics and analyses for various reports (including custom analyses) and intellectual
        capital to build products and services, demonstrate our capabilities, and improve the
        quality of our advice for the benefit of all our clients. We will not disclose any
        information in a manner that allows particular clients or individuals to be identified.
    </p>
    <p>
        8.5 You agree that we may retain copies of your confidential information under a continuing
        duty of confidentiality for the purpose of complying with its legal and regulatory
        obligations and to respond to complaints or claims made in connection with the Services.
    </p>

    <h2>9 DATA PROTECTION</h2>
    <p>
        9.1 Both you and us shall comply with our respective obligations under Data Protection Laws
        in connection with the Services.
    </p>

    <h2>10 ARTIFICIAL INTELLIGENCE AND AIDA</h2>
    <p>
        10.1 The Platform may utilise and incorporate AI Technology. You acknowledge that some
        functionality of the Platform, including Aida, may generate Materials or other responses
        solely through AI Technology that may incomplete or contain inaccurate information. Mercer
        shall solely and exclusively own any queries or prompts made by you and Users using Aida,
        including any intellectual property residing therein.
    </p>
    <p>
        10.2 You and the Users shall not include confidential information or personal data in
        queries submitted to Aida or information otherwise uploaded to the Platform.
    </p>
    <p>
        10.3 You and the Users shall use Aida for your internal research purposes only to obtain
        information on compensation, benefits and human resource policy and for no other purpose.
    </p>
    <p>
        10.4 You acknowledge that the internet is not a fully secure medium in which confidentiality
        and security can be guaranteed, and that we shall not be liable for any harm that may be
        caused by requesting a search of internet-based sources.
    </p>
    <p>
        10.5 We shall not be responsible for the accuracy, completeness, or reliability of the
        information provided in internet search results by Aida, nor do we endorse any part of the
        information provided. The information provided may be incomplete or condensed and is
        intended for general informational purposes only. Nothing in the internet search results is
        intended as, nor should it be construed as, professional advice. It is your and the Users’
        sole responsibility to verify all information independently at your discretion.
    </p>
    <p>
        10.6 You acknowledge that should you access third-party websites or information included in
        internet-based search results, all such access, use and compliance with any related
        third-party terms and conditions of use is at your sole risk. We shall have no
        responsibility whatsoever for your use of any third-party websites or information.
    </p>

    <h2>11 PUBLICITY AND USE OF NAMES</h2>
    <p>
        11.1 Any public statement, marketing material, press releases or similar that contains the
        whole or any part of the Services shall only be (a) disclosed with our prior written
        consent; and (b) accompanied by an acknowledgement that any such data, information or
        figures are supplied by us. Either party may use the other party's name in its publicity,
        provided that any reference to the other party beyond its name will be subject to prior
        approval of the party whose name is being used.
    </p>

    <h2>12 GOVERNING LAW AND JURISDICTION</h2>
    <p>
        12.1 These Engagement Terms and all matters arising out of or in relation to it shall be
        governed by and construed in accordance with the law of the jurisdiction in which we are
        located and all disputes under or in any way connected with the Engagement Terms shall be
        determined by the exclusive jurisdiction of the courts of jurisdiction in which we are
        based.
    </p>

    <h2>13 GENERAL</h2>
    <p>
        13.1 Sanctions. We are unable to provide any services or provide any benefit to the extent
        that the provision of such services or benefit would violate applicable law or expose us or
        our Affiliates to any sanction, prohibition or restriction under UN Security Council
        Resolutions or under other trade or economic sanctions, laws or regulations.
    </p>
    <p>
        13.2 Severability. It is the intent of the parties that the provisions of these terms and
        conditions shall be enforced to the fullest extent permitted by applicable law. To the
        extent that the terms and conditions contain or any word, phrase, clause or sentence is
        found to be illegal or unenforceable for any reason, such word, phrase, clause or sentence
        shall be modified deleted or interpreted in such a manner so as to afford the party for
        whose benefit it was intended the fullest benefit commensurate with making these terms and
        conditions as modified, enforceable and the balance of these terms and conditions shall not
        be affected thereby, the balance being construed as severable and independent.
    </p>
    <p>
        13.3 Survival. Any provision of the Engagement Terms that by their nature and for any reason
        are intended to survive and extend beyond the termination, cancellation or expiration of the
        Engagement Terms, shall remain in effect beyond such time.
    </p>
    <p>
        13.4 Modification and Waiver. We reserve the right to amend these terms and conditions in
        our sole discretion and as necessary from time to time. Any other modification or waiver of
        the provisions of these terms and conditions shall be effective only if made in writing and
        signed by both parties. The failure by a party to insist upon strict performance of any
        provisions of these terms and conditions shall not be construed as a waiver of such party’s
        rights arising out of any subsequent default of the same or similar nature. Any use of pre-
        printed, standard or posted term forms, including without limitation purchase orders,
        shrink-wrap agreements, click-wrap agreements, acknowledgements or invoices provided by you,
        are for your administrative and convenience uses only and any terms and conditions stated
        therein shall not have the ability, unless expressly agreed between the parties, to modify
        or override the terms contained in these terms and conditions.
    </p>
    <p>
        13.5 Transfer and Assignment, Access to the Materials and the Platform is licensed to you
        and, solely for your internal purposes to utilise the Services only. You may not rent,
        lease, sublicense, sell, assign, pledge, transfer or otherwise dispose of the access to the
        Materials or the Platform, or any of your rights, obligations or benefits under these
        Engagement Terms, in whole or in part, to any other party, on a permanent or temporary
        basis, without our prior written consent.
    </p>
    <p>
        13.6 Notices. Any notice which is to be given by one party to the other under the Engagement
        Terms will be given in writing to the relationship or account manager (including by email).
        Any notice sent by post shall be effective if delivered to the address of the other party
        set out in the Agreement or any other address specified by the receiving party subsequently.
        A notice will be effective 48 hours after delivery. Either party may change its address for
        service of notices by giving notice to the other party in accordance with this paragraph
        14.6.
    </p>
    <p>
        13.7 Bribery. Each party shall comply with all applicable laws, statutes and/or regulations
        relating to bribery and corruption, including but not limited to the Bribery Act 2010 and
        the Foreign Corrupt Practices Act 1977.
    </p>
    <p>
        13.8 Unforeseen Events. Neither party shall have any liability for any failure or delay in
        performance of our obligations under the Engagement Term because of circumstances beyond our
        reasonable control, including, without limitation, pandemics, acts of God, fires, floods,
        earthquakes, acts of war or terrorism, civil disturbances, sabotage, accidents, unusually
        severe weather, governmental actions, power failures, computer/network viruses that are not
        preventable through generally available retail products, catastrophic hardware failures or
        attacks on its servers. Neither party shall be in breach of this Engagement nor liable for
        delay in performing, or failure to perform, any of its obligations under this Engagement if
        such delay or failure results from events beyond their reasonable control. In such a case,
        either party may terminate the Engagement Terms with immediate effect by giving written
        notice to the other.
    </p>
    <p>
        13.9 Third Parties. Neither the Engagement Terms nor the provision of the Services are
        intended to confer any rights or benefit on any third party other than the rights and
        benefits conferred upon our Affiliates, officers, directors, employees, consultants and
        subcontractors as provided for by the Engagement Terms.
    </p>

    <h2>SCHEDULE 1 - PROHIBITED USE POLICY</h2>
    <div class="schedule">
        <p>
            In relation to the access to and use of the Materials to the Platform, you shall ensure
            that you shall not:
        </p>
        <ol type="a">
            <li>
                resell the usage, functionalities or services provided in the Materials or the
                Platform;
            </li>
            <li>
                create, host, display, upload, modify, publish, transmit, update, share or
                otherwise, any information, material or content which infringes the copyright,
                trademark, patent, trade secret or other intellectual property or proprietary rights
                of any person;
            </li>
            <li>
                host, display, upload, modify, publish, transmit, update, share or otherwise, any
                information, material or content:
            </li>
            <ol type="i">
                <li>which does not belong or is licensed to you;</li>
                <li>
                    which is harmful, harassing, defamatory, blasphemous, offensive, obscene,
                    pornographic, paedophilic, libelous, invasive of others' privacy, hateful,
                    racially or ethically objectionable, disparaging, relating or encouraging
                    gambling, money laundering or engaging in activities which would cause offence
                    to others on grounds of race, religion, creed, or sex or is otherwise unlawful
                    in any manner;
                </li>
                <li>for an unlawful purpose;</li>
                <li>to impersonate another person or for the purpose of impersonation;</li>
                <li>
                    that contains virus or any other computer codes, files or programs that are
                    could to harm, interrupt, destroy or limit our system or networks;
                </li>
                <li>
                    that threatens the unity, integrity, defence, security or sovereignty of any
                    nation, their relations with foreign states, or public order, or causes
                    incitement to the commission of any cognizable offence, or prevents
                    investigation of any offence, or is insulting to any nation;
                </li>
            </ol>
            <li>
                use and access the Platform in any manner which is not permitted under any license
                included herein or the Demo License and the Engagement Terms;
            </li>
            <li>
                use any information contained in the Platform or the Materials to train, validate,
                update, improve, or modify any artificial intelligence or technology;
            </li>
            <li>
                upload information contained in the Platform or the Materials to artificial
                intelligence not owned by us;
            </li>
            <li>
                use and access the Platform for any unauthorized marketing purposes or for sending
                any unsolicited materials or advertisements;
            </li>
            <li>
                engage in any network or system attacks against the Platform or any of our or our
                Affiliate’s systems or networks;
            </li>
            <li>
                act in any way that would interfere with the normal operation or functioning of the
                Materials;
            </li>
            <li>
                reverse engineer, decompile, disassemble or otherwise derive any non-public
                information or materials related to the Materials and associated software;
            </li>
            <li>access or attempt to access any source code in the Materials;</li>
            <li>
                access or attempt to access all or any part of the Materials in order to build a
                competing product; or
            </li>
            <li>attempt or undertake any security testing on the Materials.</li>
        </ol>
    </div>
</div>
